export const makeFieldName = (fieldName, name) => {
    if (!name) {
        return `${fieldName}`;
    }
    return `${name}.${fieldName}`;
};
